import React from 'react';
import { CheckCircle2Icon, GlobeIcon, LockIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
import { ScarcityBar } from './ScarcityBar';
import { includes, valueRows } from '../data/content';
export function Offer() {
  return <section id="oferta" className="w-full bg-navy px-4 py-14 text-white sm:py-20" data-id="element-158" data-mp="1hophvrrjm0hg">
      <div className="mx-auto w-full max-w-2xl" data-id="element-159" data-mp="tyv4n93ba9wo">
        <h2 className="text-center font-display text-[1.65rem] font-bold leading-tight sm:text-4xl" data-id="element-160" data-mp="tzmojmnjqj74">
          En total recibirás…
        </h2>

        <ul className="mt-7 space-y-2.5" data-id="element-161" data-mp="p24n0hbuz695">
          {includes.map(item => <li key={item} className="flex items-start gap-2.5 rounded-xl bg-white/[0.06] px-4 py-3 text-sm text-white/90 sm:text-base" data-id="element-162" data-mp="13uy5mbmfg2i1">
              <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-emerald-400" aria-hidden="true" data-id="element-163" data-mp="2famsz43lf3jd" />
              {item}
            </li>)}
        </ul>

        <p className="mt-6 text-center text-sm text-white/60 sm:text-base" data-id="element-164" data-mp="pjz3fuxdlhys">
          Todo en formato digital, con acceso inmediato y disponible para consultar siempre que lo
          necesites.
        </p>

        <div className="mt-8 overflow-hidden rounded-2xl border border-white/10 bg-white/[0.04]" data-id="element-165" data-mp="zgafcjt205sp">
          <p className="border-b border-white/10 px-4 py-3 text-[11px] font-bold uppercase tracking-[0.18em] text-gold-light" data-id="element-166" data-mp="13hvz8p409kce">
            El valor real de este sistema
          </p>
          <ul data-id="element-167" data-mp="btc5w63cpy4a">
            {valueRows.map(row => <li key={row.label} className="flex items-start justify-between gap-3 border-b border-white/[0.07] px-4 py-3 text-sm sm:text-base" data-id="element-168" data-mp="ftvyqxgw6fkm">
                <span className="text-white/75" data-id="element-169" data-mp="3k95kgfe4gzip">{row.label}</span>
                <span className="shrink-0 font-semibold text-white/90" data-id="element-170" data-mp="3k6ja67zuk5ws">{row.value}</span>
              </li>)}
            <li className="flex items-center justify-between gap-3 bg-white/[0.07] px-4 py-3.5" data-id="element-171" data-mp="vfh5ia2boxke">
              <span className="text-sm font-bold uppercase tracking-wide sm:text-base" data-id="element-172" data-mp="qgntyn6ljgmv">
                Valor total
              </span>
              <span className="font-display text-xl font-bold text-white/70 line-through decoration-red-400 sm:text-2xl" data-id="element-173" data-mp="154ikbwx4t8ws">
                USD $352
              </span>
            </li>
          </ul>
        </div>

        <div className="mt-8 rounded-3xl border-2 border-gold bg-navy-deep p-5 text-center sm:p-8" data-id="element-174" data-mp="chemqd0dbwv1">
          <p className="text-sm text-white/70" data-id="element-175" data-mp="7jcr6slra52o">
            Hoy no pagarás USD $352. Ni USD $197. Ni siquiera USD $97.
          </p>
          <p className="mt-4 text-[11px] font-bold uppercase tracking-[0.2em] text-gold-light" data-id="element-176" data-mp="lf86ypkuz01u">
            Acceso inmediato por solo
          </p>
          <p className="mt-1 font-display text-6xl font-extrabold leading-none text-gold sm:text-7xl" data-id="element-177" data-mp="1wvopwsvmfytg">
            $15
          </p>
          <p className="mt-1 text-sm font-semibold uppercase tracking-[0.2em] text-white/70" data-id="element-178" data-mp="1suuxbm78hvu8">USD</p>

          <p className="mt-3 text-sm text-white/70" data-id="element-179" data-mp="20gqhrp1uas69">
            Una sola inversión. Sin mensualidades. Sin renovaciones. Acceso de por vida.
          </p>

          <p className="mx-auto mt-4 flex max-w-sm items-center justify-center gap-2 rounded-xl bg-white/[0.07] px-3 py-2.5 text-[12px] leading-snug text-white/80 sm:text-sm" data-id="element-180" data-mp="1qh99r0z48274">
            <GlobeIcon className="h-4 w-4 shrink-0 text-gold-light" aria-hidden="true" data-id="element-181" data-mp="2j5f0q5grinfe" />
            El cambio de moneda es <strong className="font-semibold" data-id="element-182" data-mp="2o4hswpbn8z5y">automático</strong>: pagas en
            la moneda de tu país.
          </p>

          <div className="mt-6" data-id="element-183" data-mp="29ekdaxrs5hsd">
            <CTAButton label="Sí, quiero acceder a la Ruta Clínica completa" data-id="element-184" data-mp="29d95mmv7rpvz" />
          </div>

          <div className="mt-5" data-id="element-185" data-mp="2ecc0jehhcfq8">
            <Countdown tone="dark" data-id="element-186" data-mp="323hhjwz5pe24" />
          </div>

          <div className="mt-5" data-id="element-187" data-mp="322okxotww4xp">
            <ScarcityBar data-id="element-188" data-mp="36upu31vs9fji" />
          </div>

          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[11px] font-medium text-white/65 sm:text-xs" data-id="element-189" data-mp="36vhpablgxb99">
            <li data-id="element-190" data-mp="1j41qtt70dsdb">✔ Descarga inmediata</li>
            <li data-id="element-191" data-mp="1e71s63chnrw8">✔ Pago único</li>
            <li data-id="element-192" data-mp="1e60673txpkzq">✔ Acceso de por vida</li>
            <li data-id="element-193" data-mp="197ynwl4c1ppb">✔ Garantía de 7 días</li>
          </ul>

          <p className="mt-4 flex items-center justify-center gap-1.5 text-[11px] text-white/45" data-id="element-194" data-mp="198gti8cvxg9w">
            <LockIcon className="h-3 w-3" aria-hidden="true" data-id="element-195" data-mp="14ayhua7hgmy7" /> Pago seguro y encriptado
          </p>
        </div>
      </div>
    </section>;
}